import React from 'react';
import { Group, Text } from '@mantine/core';

import { useUser } from '../../hooks/useUser';
import { getS3BucketPrefix, S3CopyBucketKind } from '../../helpers/s3CopyPath';
import CopyS3PathButton from './CopyS3PathButton';
import When from './When';

type SuperAdminS3PathProps = {
    path?: string | null;
    bucket: S3CopyBucketKind;
};

function SuperAdminS3Path({ path, bucket }: SuperAdminS3PathProps) {
    const { isSuperAdmin } = useUser();

    return (
        <When condition={isSuperAdmin && Boolean(path)}>
            <Group gap={6} wrap="nowrap" className="shrink-0">
                <Text size="sm" className="whitespace-nowrap">
                    {getS3BucketPrefix(bucket)}
                </Text>
                <CopyS3PathButton path={path} />
            </Group>
        </When>
    );
}

export default SuperAdminS3Path;
